import { LeftSquareTwoTone, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Image, message, Row, Table, Space, Tooltip, Input, List, Typography } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import TextArea from 'antd/lib/input/TextArea';
import Modal from 'antd/lib/modal/Modal';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import {
  createAdminOrSubAdmin,
  findCustomerWithPhoneNumbers,
  getUserCrmUser,
  addNote,
  getNotes,
} from '../../RestServices/authService';
import { formateString, PermissionEnum } from '../../shared';
import { fontColor, MAIN_BACKGROUND_COLOR } from '../../styleConstants';
import Calender from '../../utils/CalenderDropDown/Calender';
import ContantTitle from '../../utils/contantTitle/ContantTitle';
import '../Dashboard/styles.css';
import Pagination from '../Pagination';
import AddUserModal from './AddUser';

//
// import Table from "../Table";

const styles = {
  layout: {
    minHeight: '100vh',
  },
  header: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    padding: 0,
  },
  sider: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
  },
  menu: {
    backgroundColor: MAIN_BACKGROUND_COLOR,
    color: fontColor,
    fontWeight: 'bold',
  },
  content: {
    color: fontColor,
    backgroundColor: 'white',
    margin: '20px',
  },
  logo: {
    height: '200px',
    width: '190px',
  },
  menuToggler: {
    color: fontColor,
    fontSize: '30px',
    marginLeft: '5px',
    marginTop: '15px',
  },

  tableContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  addUserButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  addUserButton: {
    marginRight: '20px',
    backgroundColor: '#1f910e',
    color: 'white',
  },
};
const columns = [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Email',
    accessor: 'email', // accessor is the "key" in the data
  },
  {
    Header: 'Role',
    accessor: 'type',
  },
  {
    Header: 'Status',
    accessor: 'status', // accessor is the "key" in the data
  },
];
class UsersListForCrm extends React.Component {
  state = {
    collapsed: false,
    input: null,
    isFormLoading: false,
    customers: [],
    totalPages: 1,
    selectedRowKeys: [],
    currentPage: 1,
    metaData: {},
    isModalOpen: false,
    name: '',
    data: {},
    email: '',
    password: '',
    permissions: [],
    type: 'ADMIN',
    city: '',
    selectedUser: {},
    rawCustomer: [],
    phoneNumber: '',
    dropdrownshow: false,
    dateSelection: {
      startDate: undefined,
      endDate: undefined,
      key: 'selection',
    },

    datesBetween: {
      startDate: undefined,
      endDate: undefined,
    },
    isModalVisible: false,
    phoneNumberText: '',
    getPhoneListLoading: false,
    ListUser: null,
    screenSwitch: false,
    noteModalVisible: false,
    noteType: 'view', // 'view' or 'add'
    currentNote: '',
    notesHistory: [],
    loadingNotes: false,
    activeCustomer: null,
  };

  onChangePermission = (permissions) => {
    this.setState({ permissions });
  };
  toggleSider = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  inputEvent = (e) => {
    this.setState({ input: e.target.value });
    console.log(e.target.value);
  };
  inputHandler = (evt) => {
    const { name, value } = evt.target;
    this.setState({ [name]: value });
  };
  openUserShowDetailModal = () => this.setState({ isModalOpen: true });
  closeUserShowDetailModal = () => this.setState({ isModalOpen: false });

  resetForm = () =>
    this.setState({
      name: '',
      email: '',
      password: '',
      city: '',
      phoneNumber: '',
      permissions: [],
    });
  submitForm = async (evt) => {
    evt.preventDefault();
    const { name, email, password, phoneNumber, city, type, permissions } =
      this.state;
    if (!name || !email || !password || !phoneNumber || !city || !type) {
      return message.error('Please fill all value ');
    }
    if (!permissions.length) {
      return message.error('Please check the some permission');
    }

    console.log(this.state, permissions);
    this.setState({ isFormLoading: true });
    try {
      const data = await createAdminOrSubAdmin(
        { ...this.state, permissions },
        this.props.Auth.user.token,
      );

      const customer = {
        name: data.customer.name,
        email: data.customer.email,
        key: data.customer._id,
        updatedAt: new Date().toISOString(),
        type: data.customer.profileDetails.type,
        status: data.customer.status,
        phoneNumber: data.customer.phoneNumber,
      };
      this.setState({
        isFormLoading: false,
        isModalOpen: false,
        customers: [customer, ...this.state.customers],
      });
      message.success('User ' + data.customer.name + ' Created!');
      this.resetForm();
    } catch (err) {
      this.setState({ isFormLoading: false });
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };

  getUserApiFunc = async () => {
    try {
      let data = await getUserCrmUser(
        {
          page: this.state.currentPage,
          userId: this.props.Auth.user._id,
          type: this.props.slectedSubkey,
          startDate: this.state.datesBetween.startDate
            ? moment(this.state.datesBetween.startDate).toDate()
            : '',
          endDate: this.state.datesBetween.endDate
            ? moment(this.state.datesBetween.endDate).toDate()
            : '',
        },
        this.props.Auth.user.token,
      );
      console.log(data, 'data abc');
      const customers = data.userDailyStat.users.docs.map((customer) => ({
        name: customer.name,
        type: customer.profileDetails.type,
        status: customer.status,
        key: customer._id,
        updatedAt: moment(customer.lastProfileFetched).format(formateString),
        createdAt: moment(customer.createdAt).format(formateString),
        phoneNumber: customer.phoneNumber,
        profileImage: customer.profileImage,
        city: customer.city,
      }));
      this.setState({
        customers,
        currentPage: data.userDailyStat.users.page,
        totalPages: data.userDailyStat.users.totalDocs,
        rawCustomer: data.userDailyStat.users.docs,
        data: data.userDailyStat.users,
      });
    } catch (err) {
      if (err.response) {
        return message.error(err.response.data.message);
      }
      return message.error(err.message);
    }
  };
  componentDidMount() {
    this.getUserApiFunc();
  }

  tableColumns = [
    {
      title: 'Sr.',
      width: 20,
      dataIndex: 'index',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Image',
      width: 20,
      dataIndex: 'profileImage',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) => (
        <Avatar src={<Image style={{ width: '80px' }} src={text} />} />
      ),
    },
    {
      key: 'name',
      title: 'Name',
      dataIndex: 'name',
    },

    {
      key: 'phoneNumber',
      title: 'Phone',
      dataIndex: 'phoneNumber',
      render: (text, record, index) => (
        <a style={{ color: 'blue' }} href={`tel:${text}`}>
          {text}
        </a>
      ),
    },
    {
      key: 'city',
      title: 'City',
      dataIndex: 'city',
    },

    {
      key: 'type',
      title: 'Rule',
      dataIndex: 'type',
    },

    {
      key: 'status',
      title: 'Status',
      // title: "Category",
      dataIndex: 'status',
    },
    {
      key: 'createdAt',
      title: 'date of Creation',
      dataIndex: 'createdAt',
    },

    {
      key: 'updatedAt',
      title: 'Last Seen',
      dataIndex: 'updatedAt',
    },
    {
      key: 'actions',
      title: 'Actions',
      width: 120,
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="View Notes">
            <Button
              shape="circle"
              icon={<EyeOutlined style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />}
              onClick={() => this.openNoteModal(record, 'view')}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            />
          </Tooltip>
          <Tooltip title="Add Note">
            <Button
              shape="circle"
              type="primary"
              icon={<PlusCircleOutlined style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} />}
              onClick={() => this.openNoteModal(record, 'add')}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  openNoteModal = (customer, type) => {
    this.setState({
      noteModalVisible: true,
      noteType: type,
      activeCustomer: customer,
      currentNote: '',
    }, () => {
      if (type === 'view') {
        this.fetchNotes(customer.key);
      }
    });
  };

  fetchNotes = async (customerId) => {
    this.setState({ loadingNotes: true });
    try {
      const response = await getNotes(customerId, this.props.Auth.user.token);
      this.setState({ notesHistory: response.notes || [], loadingNotes: false });
    } catch (err) {
      message.error('Failed to fetch notes');
      this.setState({ loadingNotes: false });
    }
  };

  handleSaveNote = async () => {
    const { currentNote, activeCustomer } = this.state;
    if (!currentNote.trim()) {
      return message.error('Please enter a note');
    }

    try {
      await addNote({
        customerId: activeCustomer.key,
        note: currentNote,
        adminId: this.props.Auth.user._id,
      }, this.props.Auth.user.token);

      message.success('Note added successfully');
      this.setState({ noteModalVisible: false, currentNote: '' });
    } catch (err) {
      message.error('Failed to add note');
    }
  };

  closeNoteModal = () => {
    this.setState({ noteModalVisible: false, notesHistory: [] });
  };

  onPageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getUserApiFunc();
    });
  };

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false, screenSwitch: false });
  };

  handleSelect = (ranges) => {
    console.log(ranges);
    if (ranges.hasOwnProperty('range1')) {
      this.setState({ dateSelection: { ...ranges.range1 } });
    } else {
      this.setState({ dateSelection: { ...ranges.selection } });
    }
  };
  PickDate = () => {
    this.setState(
      {
        dropdrownshow: false,
        datesBetween: {
          startDate: this.state.dateSelection.startDate,
          endDate: this.state.dateSelection.endDate,
        },
      },
      () => this.getUserApiFunc(),
    );
  };

  rowSelection = {
    onChange: (selectedRowKeys) => {
      const [id] = selectedRowKeys;
      const selectedUser = this.state.rawCustomer.find(
        (user) => user.id === id,
      );
      console.log(selectedUser);
      this.setState({ selectedRowKeys, selectedUser });
      this.openUserShowDetailModal();
    },
  };

  onChange = ({ target: { value } }) => {
    this.setState({ phoneNumberText: value });
  };
  fetchUserData = async () => {
    try {
      const { phoneNumberText } = this.state;
      let payload = phoneNumberText.split('\n');

      payload = payload.filter(function (el) {
        return el != '';
      });

      this.setState({ getPhoneListLoading: true });
      const response = await findCustomerWithPhoneNumbers(
        this.props.Auth.user.token,
        { phoneNumbers: payload },
      );
      this.setState({
        listUser: response.customerList,
        screenSwitch: true,
      });
      console.log(response);
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ getPhoneListLoading: false });
    }
  };
  render() {
    const {
      customers,

      totalPages,
      currentPage,

      isFormLoading,
    } = this.state;
    console.log(customers);

    const { permissions: userPermission } = this.props.Auth.user.profileDetails;

    return (
      <div style={styles.content}>
        <Modal
          title="Filter Phone Number"
          visible={this.state.isModalVisible}
          onOk={this.handleOk}
          width={window.innerWidth < 768 ? '95%' : '70%'}
          height="80vh"
          onCancel={this.handleCancel}
        >
          <Row justify="center" align="middle" gutter={[16, 16]}>
            {!this.state.screenSwitch ? (
              <Col xs={24} sm={18} md={12}>
                <p>Enter phone numbers</p>
                <TextArea
                  style={{ width: '100%' }}
                  value={this.state.phoneNumberText}
                  onChange={this.onChange}
                  placeholder="Controlled autosize"
                  autoSize={{ minRows: 3, maxRows: 15 }}
                />
                <Button
                  loading={this.state.getPhoneListLoading}
                  onClick={this.fetchUserData}
                  style={{ marginTop: '20px' }}
                  type={'primary'}
                  block={window.innerWidth < 768}
                >
                  Get Result
                </Button>
              </Col>
            ) : (
              <Col span={24}>
                <Row gutter={[12, 12]}>
                  <Col xs={24} sm={12}>
                    <p>Users Number</p>
                    <TextArea
                      style={{ width: '100%' }}
                      value={this.state.listUser?.customerList
                        ?.map((value) => value.phoneNumber)
                        ?.join('\n')}
                      // onChange={this.onChange}
                      placeholder="User"
                      autoSize={{ minRows: 3, maxRows: 15 }}
                    />
                  </Col>
                  <Col xs={24} sm={12}>
                    <p>Non Users Number</p>
                    <TextArea
                      style={{ width: '100%' }}
                      value={this.state.listUser?.notPresents?.join('\n')}
                      // onChange={this.onChange}
                      placeholder="Non User"
                      autoSize={{ minRows: 3, maxRows: 15 }}
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        </Modal>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={2} md={1}>
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <LeftSquareTwoTone
                onClick={() => {
                  if (this.props.slectedSubkey.startsWith('Crm')) {
                    this.props.setSelected('Crm_System');
                  } else {
                    this.props.setSelected('Dashboard');
                  }
                }}
                style={{
                  fontSize: '28px',
                  color: 'red',
                  margin: '10px 0',
                  cursor: 'pointer',
                }}
              />
            </div>
          </Col>
          <Col xs={24} sm={10} md={7}>
            <Breadcrumb style={{ margin: '8px 0', cursor: 'pointer', fontSize: '16px' }}>
              <Breadcrumb.Item>Admin Dashboard</Breadcrumb.Item>
              <Breadcrumb.Item>{this.props.slectedSubkey}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Button
              onClick={this.showModal}
              block
              size="large"
              style={{ marginBottom: window.innerWidth < 768 ? '8px' : '0' }}
            >
              Filter Phone Number
            </Button>
          </Col>
          <Col xs={24} md={10}>
            <div style={{
              display: 'flex',
              justifyContent: window.innerWidth < 768 ? 'center' : 'flex-end',
              width: '100%'
            }}>
              <Calender
                handleSelect={this.handleSelect}
                PickDate={this.PickDate}
                dateSelection={this.state.dateSelection}
                datesBetween={this.state.datesBetween}
                dropdrownshow={this.state.dropdrownshow}
                setdropdrownshow={(value) =>
                  this.setState({ dropdrownshow: value })
                }
                setdateSelection={(pros) =>
                  this.setState({ ...pros, dropdrownshow: false })
                }
              />
            </div>
          </Col>
        </Row>
        {(userPermission.includes(PermissionEnum['AllResources:*']) ||
          userPermission.includes(PermissionEnum['Users:*']) ||
          userPermission.includes(PermissionEnum['Users:add'])) && (
            <ContantTitle
              heading={
                this.props.slectedSubkey +
                ' Users (' +
                this.state.data?.totalDocs +
                ')'
              }
              // buttonText={"Add User"}
              openForm={console.log}
            />
          )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '10px',
          }}
          className="pagination-container"
        >
          <Pagination
            current={currentPage}
            total={totalPages}
            onPageChange={this.onPageChange}
          />
        </div>
        <Table
          dataSource={customers}
          pagination={false}
          columns={this.tableColumns}
          scroll={{ x: 'max-content' }}
          rowSelection={{
            type: 'radio',
            selectedRowKeys: this.state.selectedRowKeys,
            ...this.rowSelection,
          }}
        />

        <AddUserModal
          selectedUser={this.state.selectedUser}
          submitForm={this.closeUserShowDetailModal}
          isFormLoading={isFormLoading}
          isOpen={this.state.isModalOpen}
          closeModal={this.closeUserShowDetailModal}
          inputHandler={this.inputHandler}
        />

        <Modal
          title={this.state.noteType === 'view' ? "Notes History" : "Add New Note"}
          visible={this.state.noteModalVisible}
          onCancel={this.closeNoteModal}
          footer={[
            <Button key="back" onClick={this.closeNoteModal}>
              Close
            </Button>,
            this.state.noteType === 'add' && (
              <Button key="submit" type="primary" onClick={this.handleSaveNote}>
                Save Note
              </Button>
            ),
          ]}
          width={600}
        >
          {this.state.noteType === 'add' ? (
            <div>
              <Typography.Text strong>Adding note for: {this.state.activeCustomer?.name}</Typography.Text>
              <TextArea
                rows={4}
                value={this.state.currentNote}
                onChange={(e) => this.setState({ currentNote: e.target.value })}
                placeholder="Enter note details here..."
                style={{ marginTop: '10px' }}
              />
            </div>
          ) : (
            <List
              loading={this.state.loadingNotes}
              itemLayout="horizontal"
              dataSource={this.state.notesHistory}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography.Text strong>{item.adminId?.name || 'Admin'}</Typography.Text>
                        <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                          {moment(item.date).format('lll')}
                        </Typography.Text>
                      </div>
                    }
                    description={item.note}
                  />
                </List.Item>
              )}
              locale={{ emptyText: 'No notes found for this user' }}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});
export default connect(mapStateToProps)(UsersListForCrm);
